@if (isAvailable) {
    <div class="early-payout">
        @switch (buttonState) {
            @case (cashoutButtonStates.Allowed) {
                <button
                    ds-button
                    msThemedButton
                    variant="filled"
                    truncate="true"
                    [kind]="buttonKind"
                    [themeKind]="buttonThemeKind"
                    [size]="buttonSize"
                    (click)="submitEarlyPayout($event)">
                    {{ sitecore.earlyPayoutV2.PayOut }}
                    <span class="amount" [msAutomation]="{ earlyPayoutAmount: betslip.earlyPayout!.value }">
                        <span>{{ payoutValue | msCurrency: true }}</span>
                    </span>
                </button>
            }
            @case (cashoutButtonStates.Confirm) {
                <button ds-button kind="primary" variant="filled" truncate="true" [size]="buttonSize" (click)="submitEarlyPayout($event)">
                    {{ sitecore.earlyPayoutV2.PayOutConfirmation }}
                    <span class="amount">
                        <span>{{ payoutValue | msCurrency: true }}</span>
                    </span>
                </button>
            }
            @case (cashoutButtonStates.Preparing) {
                <button ds-button kind="primary" variant="filled" loading="true" truncate="true" [size]="buttonSize">
                    <ng-template #loadingTemplate>{{ sitecore.earlyPayoutV2.PayOutInProgress }}</ng-template>
                </button>
            }
            @case (cashoutButtonStates.PaidOut) {
                @if (buttonState === cashoutButtonStates.PaidOut && !isEpcotEnabled) {
                    <span class="ep-paid-out-bar"></span>
                }

                <button class="paidOut">
                    <span class="ep-paid-out">
                        @if (isEpcotEnabled) {
                            <div class="ep-paid-out-bar"></div>
                        } @else {
                            <vn-icon class="icon" size="16" name="theme-success-i" />
                        }
                        <span class="text">{{ sitecore.earlyPayoutV2.PaidOutOnButton }}</span>
                        @if (betslip.payoutAmount?.value) {
                            <span class="amount">
                                <span>{{ betslip.payoutAmount.value | msCurrency: true }}</span>
                            </span>
                        }
                        @if (isEpcotEnabled) {
                            <vn-icon class="icon" size="16" name="theme-success-i" />
                        }
                    </span>
                </button>
            }
            @case (cashoutButtonStates.Disabled) {
                @if (payoutPushError) {
                    <button ds-button kind="primary" variant="filled" disabled="true" truncate="true" class="ep-disabled" [size]="buttonSize">
                        {{ payoutPushError?.Title }}
                    </button>
                } @else {
                    <button ds-button kind="primary" variant="filled" disabled="true" truncate="true" [size]="buttonSize">
                        @if (isEpcotEnabled) {
                            <vn-icon class="icon locked-icon" name="theme-locked" slot="end" size="16" />
                        } @else {
                            <vn-icon class="icon locked-i-icon" name="theme-locked-i" slot="end" size="16" />
                        }
                        {{ sitecore.earlyPayoutV2.PayoutNotPossible }}
                    </button>
                }
            }
            @case (cashoutButtonStates.Completed) {
                <button class="paidOut">
                    <span class="ep-paid-out">
                        <vn-icon class="sports-check-icon icon" name="sports-check" [size]="isEpcotEnabled ? '12' : '16'" />
                        <span class="text">{{ sitecore.earlyPayoutV2.PaidOutCompleted }}</span>
                    </span>
                </button>
            }
        }
        @if (buttonState === cashoutButtonStates.Disabled && payoutPushError) {
            <div class="cashout-error-text">
                {{ payoutPushError?.Message }}
            </div>
        }
    </div>
} @else {
    @if (isNotSettledTab() && betCardRedesigned) {
        <div class="early-payout">
            <button ds-button kind="primary" variant="filled" disabled="true" truncate="true" class="ep-disabled" [size]="buttonSize">
                {{ sitecore.earlyPayoutV2.CashoutNotOfferedButtonText }}
            </button>
        </div>
    }
}
